import { render, staticRenderFns } from "./SideNavBar.vue?vue&type=template&id=58df9e7d&scoped=true&"
import script from "./SideNavBar.vue?vue&type=script&lang=js&"
export * from "./SideNavBar.vue?vue&type=script&lang=js&"
import style0 from "./SideNavBar.vue?vue&type=style&index=0&id=58df9e7d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58df9e7d",
  null
  
)

export default component.exports